<rav-modal revealSize="large" [modalId]="'accountNotes'" modalTitle="Account Notes">
  <div *ngIf="isNewNoteVisible">
    <rav-form [formGroup]="formGroup" [fields]="[{ name: 'note', type: 'textarea' }]" [hasCancel]="true"
      (cancel)="resetNewNote()" (formSubmit)="saveNotes($event.note)"></rav-form>
  </div>
  <div *ngIf="message" [class]="calloutClass">{{ message }}</div>
  <rav-table [dataSource]="dataSource" [config]="tableConfig" (actionTriggered)="onActionsTriggered($event)">
  </rav-table>
</rav-modal>
